(() => {
  const preferenceKey = 'mutae_currency_preference';
  const selector = '[data-mutae-currency-select]';
  let manualChoice = '';
  let lastWidget;
  let frame = 0;
  let forceRefresh = false;
  try { manualChoice = localStorage.getItem(preferenceKey) || ''; } catch {}

  const currentCurrency = (widget) => widget.querySelector('.ba-chosen')?.textContent.trim();
  const choose = (widget, currency) => {
    const option = [...widget.querySelectorAll('.bacurr-dropdown-choices [rel]')]
      .find((node) => node.getAttribute('rel') === currency);
    if (!option) return false;
    option.click();
    return true;
  };

  const sync = () => {
    frame = 0;
    const app = window.baCurr;
    const widget = document.querySelector('.bacurr-cur-block');
    const source = widget?.querySelector('#baCurrSelector');
    if (!app?.config || typeof app.refreshConversion !== 'function' || !source) return;
    const codes = [...source.options].map((option) => option.value);
    if (!codes.length) return;
    if (widget !== lastWidget) {
      lastWidget = widget;
      app.config.auto_pref = true;
      app.config.moneyWithCurrencyFormat = true;
      forceRefresh = true;
    }
    if (manualChoice && !codes.includes(manualChoice)) {
      manualChoice = '';
      try { localStorage.removeItem(preferenceKey); } catch {}
    }
    let currency = currentCurrency(widget);
    const desired = manualChoice || (codes.includes(currency) ? currency : app.config.user_curr);
    if (desired && desired !== currency && choose(widget, desired)) currency = desired;
    const freshPrices = [...document.querySelectorAll('span.money:not(.bacurr-money)')]
      .filter((price) => !price.querySelector('span.money'));
    if (freshPrices.length || forceRefresh) {
      freshPrices.forEach((price) => {
        window.bacurr$?.(price).removeData(['bacurr-origMoneyVal', 'bacurr-initVal', ...codes].join(' '));
      });
      app.refreshConversion();
      forceRefresh = false;
      currency = currentCurrency(widget);
    }
    document.querySelectorAll(selector).forEach((select) => {
      if ([...select.options].map((option) => option.value).join(',') !== codes.join(',')) {
        select.replaceChildren(...codes.map((code) => new Option(code, code)));
      }
      if (codes.includes(currency)) select.value = currency;
      select.disabled = !codes.includes(currency);
    });
    document.querySelectorAll('span.money.bacurr-money').forEach((price) => {
      if (!price.children.length && price.textContent.includes('в‚ґ')) {
        price.textContent = price.textContent.replaceAll('в‚ґ', '₴');
      }
    });
    const notices = document.querySelectorAll('mutae-currency-notice');
    const displayCurrency = currentCurrency(widget);
    notices.forEach((notice) => {
      notice.hidden = app.config.cart_alert_state === false ||
        !codes.includes(displayCurrency) || displayCurrency === notice.dataset.currency;
      if (notice.dataset.language !== 'uk' && app.config.cart_alert_note) {
        const message = app.config.cart_alert_note.replaceAll('[checkout_currency]', notice.dataset.currency);
        if (notice.textContent.trim() !== message) notice.textContent = message;
      }
    });
    document.documentElement.classList.add('mutae-currency-ready');
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  document.addEventListener('change', (event) => {
    const select = event.target.closest?.(selector);
    const widget = document.querySelector('.bacurr-cur-block');
    if (!select || !widget || !choose(widget, select.value)) return;
    manualChoice = select.value;
    try { localStorage.setItem(preferenceKey, manualChoice); } catch {}
    schedule();
  });
  window.addEventListener('storage', (event) => {
    if (event.key !== preferenceKey) return;
    manualChoice = event.newValue || '';
    schedule();
  });
  const relevant = 'span.money, .bacurr-cur-block, mutae-currency-notice, mutae-currency-selector';
  new MutationObserver((records) => {
    if (records.some((record) => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target?.closest(relevant)) return true;
      return [...record.addedNodes].some((node) => node.nodeType === 1 &&
        (node.matches(relevant) || node.querySelector(relevant)));
    })) schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();


